import React from 'react';
import { motion } from 'framer-motion';
import Header from './components/Header';
import InfoBar from './components/InfoBar';
import Footer from './components/Footer';
import Home from './pages/HomePage/Home';
import LoanCosts from './pages/Costs/Costs';
//import ApplyNow from './pages/ApplyNow/ApplyNow'; //Old Page - Depreciated for the new Application Page
import ContactUs from './pages/ContactUs/ContactUs';
import FAQs from './pages/FAQs/FAQs';
import './App.css';
import { Routes, Route } from 'react-router-dom';
import PrivacyStatement from './pages/Legal/PrivacyStatement';
import CreditGuides from './pages/Legal/CreditGuides';
import Complaints from './pages/Legal/Complaints';
import Disclaimer from './pages/Legal/Disclaimer';
import TargetMarket from './pages/Legal/TargetMarket';
//import ApplicationPage from './pages/Application/page';
import ApplicationPage from './pages/Application/latestPage';
import CreditReportingStatement from './pages/Legal/creditReportingStatement'

function App() {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Header />
      <InfoBar />
      <motion.main 
        className="flex-grow"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <Routes>
          <Route path="/" element={<Home />} />
          {/* <Route path="/apply-now" element={<ApplyNow />} /> */}
          {/* Old Page - Depreciated for the new Application Page */}
          <Route path="/apply-now" element={<ApplicationPage />} />
          <Route path="/costs" element={<LoanCosts />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/faqs" element={<FAQs />} />
          {/* <Route path="/legal/privacy-and-credit" element={<PrivacyAndCredit />} /> */}
          {/* <Route path="/legal/privacy-statement" element={<WebsitePrivacy />} /> */}


          {/* LEGAL ROUTES REQUIRED MATCHING THE NAME */}
          <Route path="/legal/target-market" element={<TargetMarket />} />
          <Route path="/legal/credit-guides" element={<CreditGuides />} />
          <Route path="/legal/privacy-statement" element={<PrivacyStatement />} />
          <Route path="/legal/disclaimer" element={<Disclaimer />} />
          <Route path="/legal/complaints" element={<Complaints />} />
          <Route path="/legal/credit-reporting" element={<CreditReportingStatement />} />




        </Routes>
      </motion.main>
      <Footer />
    </div>
  );
}

export default App;
